import ApiConnector from "../connector";

class AuthActions {
  login = async (username, password) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.post("/users/login/", {
        username: username,
        password: password,
      });
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.detail;
    }

    return result;
  };
  refresh = async (token) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.post(
        "/users/refresh-token/",
        { refresh: token }
      );
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
}

export default new AuthActions();
